import { PropsWithChildren } from "react";
import { TextLink } from "../link/TextLink";
import { linkContainer, navigationLink } from "./style.css";

type NavigationLinkProps = {
  to: string;
  shouldAnimate?: boolean;
  isActive: boolean;
  onClick?: () => void;
};

export const NavigationLink = ({
  isActive,
  to,
  shouldAnimate,
  onClick,
  children,
}: PropsWithChildren<NavigationLinkProps>) => {
  return (
    <div
      className={
        isActive && shouldAnimate ? linkContainer.active : linkContainer.default
      }
    >
      <TextLink
        className={isActive ? navigationLink.active : navigationLink.default}
        onClick={onClick}
        to={to}
      >
        {children}
      </TextLink>
    </div>
  );
};
